import React, { Suspense } from 'react';
import { prop } from 'ramda';
import { useAppSelector, useDeviceSelector, useUserSelector } from '@core/js/store/hooks';
import * as urlUtil from '@theme/js/utils/url.util';
import { useTranslations } from '@core/js/hooks/i18n';
import { getURLParam } from '@theme/js/utils/url.util';
import { BackboneReplacer } from '@theme/js/backbone/components/BackboneReplacer';
import { Language } from '@theme/js/components/main/DefaultHeader/components/Language';
import { LogoutButton } from './components/LogoutButton';
import { Link } from '@theme/js/components/common/Link';

import style from './HeaderBottomSection.scss';

export const HeaderBottomSection: React.FC = () => {
    const translate = useTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isMobile = useDeviceSelector(prop('isMobile')); /* Lugano changes */
    const chatWidget = useAppSelector(prop('chatWidget'));
    const hideChatByUrl = urlUtil.getLocationParam('hideChat') === '1';
    const showChat = chatWidget.enabled && chatWidget.showIcon && !hideChatByUrl;
    const helpBtnLink = translate('playtech.mobile.system.header.helpBtn.link');
    const hideHeaderByUrl = getURLParam(location.search, 'hideHeader') === '1';
    const hideDesktopHeaderByUrl = getURLParam(location.search, 'showHeaderOnlyOnMobile') === '1';

    if (hideHeaderByUrl) {
        return null;
    }

    if (hideDesktopHeaderByUrl && !isMobile) {
        return null;
    }

    return (
        <div className={style.container}>
            {/* Help section */}
            <div className={`${style.controlItem} ${style.controlHelpItem}`}>
                <Link href={helpBtnLink}
                   className={`${style.helpItemLink} ${style.itemLink}`}
                   aria-label={translate('playtech.mobile.system.header.helpBtn')}
                >
                    <span className={`${style.helpItemLinkIcon} icon-ico-s4w-help`}></span>
                    <span className={`${style.helpItemLinkName}`}>{translate('playtech.mobile.system.header.helpBtn')}</span>
                </Link>
            </div>

            {/* Chat section */}
            {showChat &&
                <div className={`${style.controlItem} ${style.controlChatItem}`}>
                    <BackboneReplacer
                        isHideBackboneClass={true}
                        dynamicName="CHAT_BUTTON"
                        viewName="chatbutton"
                    />
                </div>
            }

            {/* Logout section */}
            {isLoggedIn && (
                <div className={`${style.controlItem} ${style.controlLogoutItem}`}>
                    <Suspense fallback="">
                        <LogoutButton />
                    </Suspense>
                </div>
            )}

            {/* Language section */}
            <div className={`${style.controlLanguageItem}`}>
                <Language />
            </div>
        </div>
    );
};
